
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ExtraServiceSubtypeSelect from '@/components/inputs/ExtraServiceSubtypeSelect.vue';
import ExtraServicePrice from '../../models/extra_service_price';
import TextEditor from '@/components/inputs/TextEditor.vue';

/** N-301: los campos con `rules="required"` de cada fila, con la clave de su rótulo. Si se cambia uno arriba, aquí también. */
const OBLIGATORIOS = [
	['extra_service_type_id', 'subtype'],
	['people_min', 'people_min'],
	['people_max', 'people_max'],
	['price', 'price'],
	['description', 'description'],
];

/** Lo mismo que `required` de vee-validate 3: vacío es null, undefined, false o texto en blanco. */
function estaVacio(valor) {
	return [null, undefined, false].includes(valor) || String(valor).trim().length === 0;
}

/** «A», «A y B», «A, B y C». */
function enumerar(partes: string[]) {
	return partes.length > 1 ? partes.slice(0, -1).join(', ') + ' y ' + partes[partes.length - 1] : partes.join('');
}

@Component({
	components: {
		TextEditor,
		ValidationProvider,
		ValidationObserver,
		ExtraServiceSubtypeSelect,
	},
})
export default class ExtraServicePrices extends Vue {
	@Prop({ default: null, required: true }) private extra_service_prices;
	@Prop({ default: null, required: true }) private children_type_id;
	@Prop({ default: null, required: false }) private errors;

	private prices: ExtraServicePrice[] = [];
	private type_id: any = [];
	/** N-301: lo que faltaba la última vez que se validó (vacío hasta pulsar GUARDAR o CREAR). */
	faltasVistas: string[] = [];

	$refs!: {
		obs: InstanceType<typeof ValidationObserver>;
	};

	mounted() {
		if (this.extra_service_prices) {
			this.prices = this.extra_service_prices;
		}
	}

	addPriceRow() {
		this.prices.push(new ExtraServicePrice());
	}

	deletePrice(extraServicePrice) {
		const index = this.prices.indexOf(extraServicePrice);
		this.prices.splice(index, 1);
	}

	/** N-301: «Tarifa 2: falta Precio y Descripción», una línea por fila incompleta. */
	faltas(): string[] {
		return this.prices
			.map((fila, indice) => {
				const vacios = OBLIGATORIOS.filter(([campo]) => estaVacio(fila[campo])).map(([, rotulo]) => String(this.$t(rotulo)));
				return vacios.length ? `Tarifa ${indice + 1}: falta ${enumerar(vacios)}` : '';
			})
			.filter(linea => linea);
	}

	async validate() {
		this.$emit('input', this.prices);
		const valida = await this.$refs.obs.validate();
		this.faltasVistas = valida ? [] : this.faltas();
		return valida;
	}
}
